import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
import { GetCompanyBase } from './agency.model';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class GetHTTPServiceCompany extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent, public general: GeneralService, private ngxService: NgxUiLoaderService) {
    super();
  }
  public execute(newState: GetCompanyBase): void {
    this.getCompanyList(newState).subscribe(x => super.next(x)
    );
    this.ngxService.stop()
  }

  getCompanyList(newState?: GetCompanyBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Company/GetCompanies", newState)
      .pipe(map(
        (response: any) =>
        (<any>{
          result: response['result'],
          count: response['count']
        }
        ))
      )
  }
}
